import React, { useCallback, useEffect } from 'react';
import NavigateRightUp from '@uber/base-icons/navigate-right-up';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import _isEmpty from 'lodash/isEmpty';
import { TASK_MODE } from '../../../../common/task-state/constants';
import ToolbarButton from '../../../../common/toolbar-button';
import { TOOL } from '../../../labelling/constants';
import useShortcut from '../../../labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../../labelling/providers/utils/shortcut';
import { annotationUnderUserReviewAtom } from '../../atoms/annotation-atoms';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { taskModeAtom } from '../../atoms/task-mode-atoms';
import { isLoadingAtom, selectedToolAtom } from '../../atoms/tool-atoms';
export const PointerControl = () => {
  const selectedTool = useAtomValue(selectedToolAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const [taskMode] = useAtom(taskModeAtom);
  const isToolLoading = useAtomValue(isLoadingAtom);
  const annotationUnderUserReview = useAtomValue(annotationUnderUserReviewAtom);
  let {
    registerHotKeys
  } = useShortcut();
  const isDisabled = isToolLoading || !_isEmpty(annotationUnderUserReview);
  const handlePointerSelect = useCallback(() => {
    //Will disable allowing pointer tool selection in review mode in future
    //For now, we are just preventing the deselection of annotations in review mode
    if (taskMode === TASK_MODE.REVIEW) {
      selectedTool !== TOOL.POINTER && dispatch({
        type: EVENTS.SELECT_TOOL,
        tool: TOOL.POINTER
      });
      return;
    }
    dispatch({
      type: EVENTS.SELECT_ANNOTATION_LABEL,
      annotationLabel: null
    });
  }, [dispatch, taskMode, selectedTool]);
  useEffect(() => {
    if (isDisabled) return;
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['s'],
      onAction: handlePointerSelect
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [handlePointerSelect, registerHotKeys, isDisabled]);
  return <ToolbarButton title="Pointer" isSelected={selectedTool === TOOL.POINTER} onClick={handlePointerSelect} disabled={isDisabled}>
      <NavigateRightUp title="Pointer" />
    </ToolbarButton>;
};